module.exports = __webpack_public_path__ + "static/media/mindset@3x.07add14e.png";